import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/PublicNav";

const COLS = [
  { title: "Platform", links: [["Find Agencies", "/agencies"], ["Services", "/services"], ["How It Works", "/how-it-works"], ["Pricing", "/pricing"]] },
  { title: "For Agencies", links: [["Join as Agency", "/for-agencies"], ["Subscription Plans", "/pricing"], ["Agency Login", "/login"]] },
  { title: "Company", links: [["About Us", "/about"], ["Contact", "/contact"], ["FAQ", "/faq"], ["Cities", "/agencies"]] },
  { title: "Legal", links: [["Terms & Conditions", "/legal/terms"], ["Privacy Policy", "/legal/privacy"], ["Marketplace Disclaimer", "/legal/disclaimer"], ["Verification Policy", "/legal/verification"]] },
];

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-navy-300">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-6">
        <div className="lg:col-span-2">
          <Logo light />
          <p className="mt-4 text-sm text-navy-400 max-w-xs leading-relaxed">
            India's verified security services marketplace. Find. Compare. Hire. Manage — one platform for professional security services.
          </p>
          <p className="mt-4 brand-label text-brand">Find · Compare · Hire · Manage</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map(([l, to]) => (
                <li key={l}><Link to={to} className="text-sm text-navy-400 hover:text-brand transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-navy-800">
        <div className="max-w-7xl mx-auto px-6 py-8 grid gap-6 md:grid-cols-3 text-xs text-navy-500">
          <div>
            <p className="text-navy-300 font-semibold">Vent Cure Hospitality LLP</p>
            <p className="mt-1 leading-relaxed">215/Loha Bhavan, Near Old High Court, Income Tax, Navrangpura, Ashram Road, Ahmedabad - 380013</p>
          </div>
          <div>
            <p className="text-navy-300 font-semibold">GSTIN</p>
            <p className="mt-1 font-mono">24ABAFV4369A2ZE</p>
          </div>
          <div className="md:text-right">
            <p>© {new Date().getFullYear()} Vent Cure Hospitality LLP. All rights reserved.</p>
            <p className="mt-1">GuardDekho.com is a technology marketplace facilitating connections between customers and security service providers.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function PublicLayout({ children }) {
  return <div className="min-h-screen flex flex-col">{children}</div>;
}
